export const SEARCH_COST_CODE_ASYNC = 'SEARCH_COST_CODE_ASYNC';
export const SEARCH_COST_CODE_SUCCESS = 'SEARCH_COST_CODE_SUCCESS';
export const SEARCH_COST_CODE_FAIL = 'SEARCH_COST_CODE_FAIL';

export const CREATE_COST_CODE_ASYNC = 'CREATE_COST_CODE_ASYNC';
export const CREATE_COST_CODE_SUCCESS = 'CREATE_COST_CODE_SUCCESS';
export const CREATE_COST_CODE_ERROR = 'CREATE_COST_CODE_ERROR';

export const EDIT_COST_CODE_ASYNC = 'EDIT_COST_CODE_ASYNC';
export const EDIT_COST_CODE_SUCCESS = 'EDIT_COST_CODE_SUCCESS';
export const EDIT_COST_CODE_ERROR = 'EDIT_COST_CODE_ERROR';

export const GET_COST_CODE_SELECT_LIST_ASYNC =
  'GET_COST_CODE_SELECT_LIST_ASYNC';
export const GET_COST_CODE_SELECT_LIST_SUCCESS =
  'GET_COST_CODE_SELECT_LIST_SUCCESS';
export const GET_COST_CODE_SELECT_LIST_ERROR =
  'GET_COST_CODE_SELECT_LIST_ERROR';

export const RESET_ERROR_MESSAGE = 'RESET_ERROR_MESSAGE';
export const RESET_COST_CODE = 'RESET_COST_CODE';

export const MAKE_COST_CODE_ACTIVE_ASYNC = 'MAKE_COST_CODE_ACTIVE_ASYNC';
export const MAKE_COST_CODE_INACTIVE_ASYNC = 'MAKE_COST_CODE_INACTIVE_ASYNC';



// WEBPACK FOOTER //
// ./src/CostCodes/constants.js